import { Component, OnInit } from '@angular/core';

import { ArkUnitOfWork, BreezeDxStoreService } from '../../core/core.module';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { DevExtremeModule } from 'devextreme-angular';

@Component({
    selector: 'app-add-person-existing',
    templateUrl: './add-person-existing.component.html',
    styleUrls: ['./add-person-existing.component.scss'],
    imports: [DevExtremeModule]
})
export class AddPersonExistingComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    routerOption: any;
    people: any;
    familyId: number;
    personId: number;
    person: any;

    constructor(public modalRef: BsModalRef, private uow: ArkUnitOfWork, private storeService: BreezeDxStoreService, private modalService: BsModalService) {}

    async ngOnInit() {
        const query = this.uow.people.baseQuery();
        this.people = (await this.uow.executeQuery(query)) as any[];
    }
    async save() {
        this.person = await this.uow.people.byId(this.personId);
        if (!this.person) return;
        this.person.familyId = this.familyId;
        this.result.next({ result: true });
        this.modalRef.hide();
    }
    cancel() {
        this.modalRef.hide();
    }
}
